var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"img-wrapper",style:({'background-color': _vm.icon.transparent ? 'transparent' : _vm.selectedProject.siteTheme.buttonLight.background}),on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }